import React from 'react'
import { ButtonLink } from '../components/buttons'

export const Welcome = ({ ready }) => {
  if (!ready) {
    return null
  }

  return (
    <div className="container-md py-64">
      <div className="bg-white border-1 border-gray-200 shadow-100 rounded-10 px-20 sm:px-56 py-32 text-center">
        <div className="text-40 mb-24">👋</div>
        <h2 className="text-30 text-purple-dark mb-20">Welcome to Bubbel!</h2>
        <p className="mb-20">
          Navigating social dynamics during COVID is hard, especially when
          everyone has different safety practices and comfort levels.
        </p>
        <p className="mb-56">
          Bubbel helps you make safer decisions by allowing you to easily keep
          track of the people you've been seeing and activities you (and them)
          have been engaging in.
        </p>
        <ButtonLink
          to="/register"
          className="bg-purple-light text-white rounded-10"
        >
          Get Started
        </ButtonLink>
      </div>
    </div>
  )
}
